module.exports = __webpack_public_path__ + "static/media/no_search.51de0dc6.png";